import { useMutation } from '@tanstack/react-query';

import type {
  MutationResponse,
  ReorderStaffSpecialistsParams,
  StaffResponse,
  ToggleStaffLockParams,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useReorderStaffSpecialistsMutation = () =>
  useMutation({
    mutationFn: (params: ReorderStaffSpecialistsParams) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: `${params.url}/reorder`,
        data: { ids: params.ids },
      }),
  });

export const useToggleStaffLockMutation = () =>
  useMutation({
    mutationFn: (params: ToggleStaffLockParams) =>
      HttpClient.request<StaffResponse>({
        method: 'PUT',
        url: `${params.url}/${params.id}/${params.action}`,
      }),
  });
